import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/communication/')({
    beforeLoad: () => { throw redirect({ to: '/communication/email' }) },
    staticData: {
        crumb: {
            label: 'Communications',
        },
    },
})
